import axios from "axios";
import { header } from "./header";

export const getHelpContent = async(obj) => {
    try{
     const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/OrgApi/GetHelpContent`,{headers:header()})
      return response;      
    }catch (error){
      return error
    }
  }

  export const getBroadcastContent = async(obj) => {
    try{
     const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/OrgApi/GetBroadcastDetails?countryCode=${localStorage.getItem("CountryCode")}`,{headers:header()})
      return response;      
    }catch (error){
      return error
    }
  }
